import styles from './ProgressLine.module.less'

function ProgressLine(props: { percent: number }) {
  // 这里默认最小给一个百分比，防止0%的时候，动画不执行
  const minPercent = 0.1
  const percent = props.percent <= minPercent ? minPercent : props.percent > 1 ? 1 : props.percent
  return (
    <div className={styles.progressLine}>
      <div className={styles.lineBox} style={{ width: `${percent * 100}%` }}>
        <div className={styles.line}></div>
      </div>
    </div>
  )
}

export default ProgressLine
